import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.90461 0.491135L10.672 0L11.2228 0.720026C12.0411 1.78979 12.4988 2.93825 12.2877 4.10945C12.0879 5.21775 11.3324 6.10577 10.2835 6.81728C10.6986 7.76932 10.6371 8.86797 10.2863 10.0044L10.1918 10.3105C10.8224 10.9251 11.2235 11.7784 11.4585 12.7589L11.5542 13.158C13.4408 13.3692 15.2099 15.035 14.9798 17.0004C14.8547 18.0681 14.1437 18.9838 12.9447 19.5701L12.0657 20L11.1931 18.268L12.0721 17.8382C12.6655 17.548 12.9041 17.2214 12.9912 16.9549C12.2709 17.3961 11.4871 17.6196 10.6536 17.5326C9.58462 17.421 8.63257 16.8181 7.79008 15.9405L7.1319 15.2548L7.81166 14.59C7.98342 14.422 8.15887 14.2693 8.3372 14.1316C7.93047 14.0644 7.54222 13.9337 7.1789 13.7285C6.13061 13.1365 5.52501 12.058 5.21258 10.7549L5 9.86817L5.8858 9.60654C6.13478 9.533 6.38186 9.47251 6.62595 9.42687C6.41949 9.224 6.23925 8.99669 6.0893 8.74267C5.48199 7.7138 5.50994 6.48127 5.90528 5.20075L6.17244 4.3354L7.06657 4.54048C7.31158 4.59667 7.54889 4.6626 7.77682 4.73922C7.66041 4.27151 7.63484 3.79617 7.72122 3.31701C7.93223 2.14656 8.76292 1.22179 9.90461 0.491135Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }